import React from 'react';
import noScroll from 'no-scroll';

const doNothing = e => e.stopPropagation();
const KEY_ESC = 27;

class Modal extends React.Component {
  constructor() {
    super();

    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onKeyDown(e) {
    e.keyCode === KEY_ESC && this.props.onClose();
  }

  componentDidMount() {
    noScroll.on();
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentDidUpdate(prevProps) {
  }

  componentWillUnmount() {
    noScroll.off();
    document.removeEventListener('keydown', this.onKeyDown);
  }

  render() {
    const { children, headerChildren, onClose, component } = this.props;
    return (
      <div className="jl-modal__overlay" onClick={onClose}>
        <div
          className="jl-modal__container"
          onClick={doNothing}
          role="dialog"
          ref={node => (this.node = node)}
          aria-live="polite"
          aria-label={component}
        >
          <header className="jl-modal__header">
            {headerChildren}
            <button
              className="jl-modal__headerButton"
              aria-label={`Close ${component}`}
              onClick={onClose}
            >
              <span className="jl-modal__headerButton-label">Close</span>
            </button>
          </header>
          <div className="jl-modal__children">{children}</div>
        </div>
      </div>
    );
  }
}

export default Modal;
